import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { NewFbrRequest, NewFbrResponse, FbrItemClientModel, FbrClientModel, GetVesselFbrPerformanceResponse } from "../../models/fbrs/fbr.models";
import { FbrRoutes } from "../../constants/fbr/fbr.constants";

@autoinject
export class FbrService {

    constructor(private requestClient: RequestClientService) { }

    save(request: NewFbrRequest): Promise<NewFbrResponse> {
        return this.requestClient.postFormData(FbrRoutes.Save, request);
    }

    getFbr(id: number): Promise<FbrClientModel> {
        return this.requestClient.get(`${FbrRoutes.GetFbr}/${id}`, {});
    }

    getFbrItems(id: number): Promise<FbrItemClientModel[]> {
        return this.requestClient.get(`${FbrRoutes.GetFbrItems}/${id}`, {});
    }

    getVesselFbrPerformance(vesselId: number): Promise<GetVesselFbrPerformanceResponse> {
        return this.requestClient.get(`${FbrRoutes.GetVesselFbrPerformance}/${vesselId}`, {});
    }

    changeStatus(id: number, fbrStatusId: number, comments: string, meta: string, subtaskTypes: number[], statusSnippet: string): Promise<void> {
        return this.requestClient.post(FbrRoutes.ChangeStatus, {}, {
            id: id,
            comments: comments,
            statusId: fbrStatusId,
            meta: meta,
            subtaskTypes: subtaskTypes,
            statusSnippet: statusSnippet
        });
    }

    saveComments(fbrId: number, fbrItemComments: { 
        comment: string; fbrItemId: number;
        flagForAllVets: boolean;
        flagForCustomer: boolean;
    }[], otherComments: string): Promise<void> {
        return this.requestClient.post(`${FbrRoutes.SaveFbrItemComments}`, {}, {
            fbrId: fbrId,
            fbrItemComments: fbrItemComments,
            otherComments: otherComments
        });
    }

    terminalTakeDecision(id: number, statusId: number, statusSnippet: string): Promise<void>{
        return this.requestClient.post(FbrRoutes.TerminalTakeDecision, {}, {
            id: id,
            statusId: statusId,
            statusSnippet: statusSnippet
        })
    }
}